import { makeStyles } from "@material-ui/styles";

const gameSetStyles = makeStyles((theme) => ({
	title: {
		fontSize: 12,
		textAlign: "center",
		padding: "0 20px",
		width: 60
	},
	small: {
		fontSize: 9,
		lineHeight: "18px"
	},
	columnTitle: {
		fontSize: 9,
		lineHeight: "18px",
		width: 45,
		textAlign: "center"
	},
	score: {
		"& input": {
			"&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
				"-webkit-appearance": "none",
				display: "none"
			},
			textAlign: "center"
		}
	},
	scoreInput: {
		paddingTop: 5
	},
	notchedOutline: {
		borderColor: "red"
	},
	players: {
		padding: theme.spacing(0, 2),
		width: 300
	},
	rank: {
		maxWidth: 50,
		padding: "0 5px",
		marginLeft: 10
	},
	tiebreak: {
		position: "absolute",
		right: 5,
		top: -15,
		color: "#5B5B5B",
		fontFamily: "Roboto",
		fontSize: "0.745rem !important"
	},
	tiebreakInput: {
		width: 38,
		"& input": {
			fontSize: ".8em",
			paddingLeft: 11,
			paddingRight: 11
		}
	},
	selectedSet: {
		backgroundColor: "rgb(91, 91, 91, 0.1)",
		borderRadius: "5px"
	},
	column: {
		justifyContent: "space-evenly",
		display: "flex",
		flexDirection: "column",
		height: 180,
		padding: "0 5px"
	},
	set: {
		padding: 5
	},
	spacing: {
		width: 20
	},
	spacingXs: {
		width: 5
	},
	disabled: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderStyle: "dashed",
			borderColor: "rgba(0, 0, 0, 0.23) !important"
		}
	},
	textDisabled: {
		color: theme.palette.text.disabled
	}
}));

export default gameSetStyles;
